import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
    root: {
        padding: 0,
        border: 0,

        '&:hover': {
            textDecoration: 'underline',
        },
    },
}))
